import request from '../../axios/axiosconfig.js'

/**
 * 查询代理列表
 * @param {*} params 
 * @returns 
 */
export function getAllCsList(params) {
  return request({
    url: '/ps/csRelation/getAllCs',
    method: 'get',
    params: params
  })
}

/**
 * 添加代理
 * @param {*} params 
 * @returns 
 */
export function addCs(params) {
  return request({
    url: '/ps/csRelation/addCsAccount',
    method: 'post',
    data: params
  })
}

/**
 * 查询代理详细信息
 * @param {*} params 
 * @returns 
 */
export function getCsInfoById(params) {
  return request({
    url: '/ps/csRelation/getCsInfoById/'+params,
    method: 'get'
  })
}

/**
 * 查询代理门店信息
 * @param {*} id 
 * @param {*} params 
 * @returns 
 */
export function getCsStoreInfo(id,params) {
  return request({
    url: '/ps/csRelation/getStoreByCsId/'+id,
    method: 'get',
    params: params
  })
}

/**
 * 操作账户
 * @param {*} params 
 * @returns 
 */
 export function operationAccount(params) {
  return request({
    url: '/ps/csRelation/operationAccount',
    method: 'post',
    data: params
  })
}

/**
 * 根据代理id查询商户列表
 * @param {*} params 
 * @returns 
 */
 export function getBsByCsId(params) {
  return request({
    url: '/ps/csRelation/getBsByCsId',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/relation/csrelation.js